import { AddressProto } from "@noom/noom-contracts/noom_contracts/billing/address/address";
import {
  CivilDateProto,
  CivilDateTimeProto,
} from "@noom/noom-contracts/noom_contracts/lib/time/civil_time";

import { PhoneNumber } from "@/components/form";
import { Address } from "@/models";

export function buildAddressProto(
  address: Address,
  phoneNumber?: PhoneNumber,
  recipient?: string,
): AddressProto {
  const proto: AddressProto = {
    addressLine1: address.address1,
    addressLine2: address.address2,
    city: address.city,
    zoneCode: address.region,
    postalCode: address.zipcode,
    countryCode: address.country,
  };
  if (phoneNumber) {
    proto.phoneNumber = phoneNumber.dialCode.concat(phoneNumber.value);
  }
  if (recipient) {
    proto.recipient = recipient;
  }
  return proto;
}

export function createCivilDate(d: Date): CivilDateProto {
  return {
    day: d.getDate(),
    // CivilDateProto expects month in range [1, 12]
    month: d.getMonth() + 1,
    year: d.getFullYear(),
  };
}

export function createCivilDateTime(t: Date): CivilDateTimeProto {
  return {
    date: createCivilDate(t),
    time: {
      hour: t.getHours(),
      minute: t.getMinutes(),
      second: t.getSeconds(),
    },
  };
}
